import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SoapIcon(props: IconProps) {
    return <Icon {...props} iconKey={"soap"}/>
}
